import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import { getCookie__c } from "../plugins/cookies";

const RequirementForm = () =>
  import("../views/RequirementForm/RequirementForm");
const RequirementList = () =>
  import("../views/RequirementForm/RequirementList");
const RequirementPreview = () =>
  import("../views/RequirementForm/RequirementPreview");
const MainProject = () => import("../views/ProjectManagement/MainProject");
const MainProjectOffer = () =>
  import("../views/ProjectManagement/MainProjectOffer");
const MainProjectForm = () =>
  import("../views/ProjectManagement/MainProjectForm");
const ConsiderFormList = () =>
  import("../views/ProjectManagement/ConsiderFormList");
const ProjectOfferFromRSP = () =>
  import("../views/ProjectManagement/ProjectOfferFromRSP");
const AvailablePlan = () => import("../views/ProjectManagement/AvailablePlan");
const AvailablePlanList = () =>
  import("../views/ProjectManagement/AvailablePlanList");
const AvailablePlanListEdit = () =>
  import("../views/ProjectManagement/AvailablePlanListEdit");
const PlanOfferList = () => import("../views/ProjectManagement/PlanOfferList");
const AllocatedProjectList = () =>
  import("../views/ProjectManagement/AllocatedProjectList");
const ProgressFollowed = () =>
  import("../views/ProjectManagement/ProgressFollowed");
const MonthlyProgressList = () =>
  import("../views/ProjectManagement/MonthlyProgressList");
const MonthlyProgressForm = () =>
  import("../views/ProjectManagement/MonthlyProgressForm");
const ProgressReportList = () =>
  import("../views/ProjectManagement/ProgressReportList");
const ReportFromRSPList = () =>
  import("../views/ProjectManagement/ReportFromRSPList");
const ProgressReportOfferList = () =>
  import("../views/ProjectManagement/ProgressReportOfferList");
const FormA = () => import("../views/ProjectManagement/FormA");
const FormB = () => import("../views/ProjectManagement/FormB");
const FormC = () => import("../views/ProjectManagement/FormC");
const Dashboard = () => import("../views/dashboard/Dashboard");
const ConsiderForm = () => import("../views/ProjectManagement/ConsiderForm");
const ConsiderResult = () =>
  import("../views/ProjectManagement/ConsiderResult");
const EvaluateForm = () => import("../views/ProjectManagement/EvaluateForm");
const EvaluateView = () => import("../views/ProjectManagement/EvaluateView");
const EvaluateList = () => import("../views/ProjectManagement/EvaluateList");

const USPExtendTimeList = () =>
  import("../views/ProjectManagement/ExtendTime/USP/Index");
const USPExtendTimeForm = () =>
  import("../views/ProjectManagement/ExtendTime/USP/Form");
const USPExtendTimeDetail = () =>
  import("../views/ProjectManagement/ExtendTime/USP/Detail");

const SPExtendTimeList = () =>
  import("../views/ProjectManagement/ExtendTime/SP/Index");
const SPExtendTimeForm = () =>
  import("../views/ProjectManagement/ExtendTime/SP/Form");
const SPExtendTimeDetail = () =>
  import("../views/ProjectManagement/ExtendTime/SP/Detail");

const RSPExtendTimeList = () =>
  import("../views/ProjectManagement/ExtendTime/RSP/Index");
const RSPExtendTimeForm = () =>
  import("../views/ProjectManagement/ExtendTime/RSP/Form");
const RSPExtendTimeDetail = () =>
  import("../views/ProjectManagement/ExtendTime/RSP/Detail");

Vue.use(VueRouter);

// silence the rejection and make the promise resolve with the error instead
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/requirement",
    name: "RequirementList",
    meta: {
      bcName: "Requirement Form",
    },
    component: RequirementList,
  },
  {
    path: "/requirement-form/:id",
    name: "RequirementForm",
    meta: {
      parentName: "RequirementList",
      bcName: "แบบฟอร์มความต้องการเทคโนโลยี",
    },
    component: RequirementForm,
  },
  {
    path: "/requirement-preview/:id",
    name: "RequirementPreview",
    meta: {
      parentName: "RequirementList",
      bcName: "แบบฟอร์มความต้องการเทคโนโลยี",
    },
    component: RequirementPreview,
  },
  {
    path: "/project-management",
    name: "ProjectManagement",
    meta: {
      bcName: "จัดการโครงการ",
    },
    redirect: () => ({ name: "AvailablePlan" }),
  },
  {
    path: "/main-project",
    name: "MainProject",
    meta: {
      parentName: "ProjectManagement",
      bcName: "โครงการหลัก",
    },
    component: MainProject,
  },
  {
    path: "/main-project-form",
    name: "MainProjectForm",
    meta: {
      parentName: "MainProject",
      bcName: "แก้ไขข้อมูลโครงการหลัก",
    },
    component: MainProjectForm,
  },
  {
    path: "/consider-form",
    name: "ConsiderFormList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "แบบฟอร์มพิจารณา",
    },
    component: ConsiderFormList,
  },
  {
    path: "/consider-form/form",
    name: "ConsiderForm",
    meta: {
      parentName: "ProjectManagement",
      bcName: "แบบฟอร์มพิจารณา",
    },
    component: ConsiderForm,
  },
  {
    path: "/consider-form/form/:id",
    name: "ConsiderFormEdit",
    meta: {
      parentName: "ProjectManagement",
      bcName: "แบบฟอร์มพิจารณา",
    },
    component: ConsiderForm,
  },
  {
    path: "/consider-result/:form_b_id",
    name: "ConsiderResult",
    meta: {
      parentName: "ProjectManagement",
      bcName: "แบบฟอร์มพิจารณา",
    },
    component: ConsiderResult,
  },
  {
    path: "/evaluate-form/:id",
    name: "EvaluateForm",
    meta: {
      parentName: "EvaluateList",
      bcName: "แบบฟอร์มพิจารณาแผนงาน",
    },
    component: EvaluateForm,
  },
  {
    path: "/evaluate-list",
    name: "EvaluateList",
    meta: {
      bcName: "พิจารณาแผนงาน",
    },
    component: EvaluateList,
  },
  {
    path: "/evaluate-view/:id",
    name: "EvaluateView",
    meta: {
      parentName: "EvaluateList",
      bcName: "แบบฟอร์มพิจารณาแผนงาน",
    },
    component: EvaluateView,
  },
  {
    path: "/available-plan",
    name: "AvailablePlan",
    meta: {
      parentName: "ProjectManagement",
      bcName: "แผนงานที่เปิดรับ",
    },
    component: AvailablePlan,
  },
  {
    path: "/available-plan-list",
    name: "AvailablePlanList",
    meta: {
      parentName: "AvailablePlan",
      bcName: "รายการแผนงานที่เปิดรับ",
    },
    component: AvailablePlanList,
  },
  {
    path: "/available-plan-edit",
    name: "AvailablePlanListEdit",
    meta: {
      parentName: "AvailablePlanList",
      bcName: "แก้ไข",
    },
    component: AvailablePlanListEdit,
  },
  {
    path: "/project-a-form",
    name: "FormA",
    meta: {
      parentName: "AvailablePlan",
      bcName: "รูปแบบข้อเสนอโครงการแผนงานหลัก",
    },
    component: FormA,
  },
  {
    path: "/project-b-form",
    name: "FormB",
    meta: {
      parentName: "MainProjectOffer",
      bcName: "สร้างแบบฟอร์ม",
    },
    component: FormB,
  },
  {
    path: "/project-c-form",
    name: "FormC",
    meta: {
      parentName: "AvailablePlan",
      bcName: "ยื่นโครงการ",
    },
    component: FormC,
  },
  {
    path: "/plan-offer",
    name: "PlanOfferList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "ข้อเสนอโครงการ",
    },
    component: PlanOfferList,
  },
  {
    path: "/allocated-project",
    name: "AllocatedProjectList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "โครงการที่ได้รับการจัดสรร",
    },
    component: AllocatedProjectList,
  },
  {
    path: "/progress-follow",
    name: "ProgressFollowed",
    meta: {
      parentName: "ProjectManagement",
      bcName: "ติดตามความก้าวหน้า",
    },
    component: ProgressFollowed,
  },
  {
    path: "/monthly-progress",
    name: "MonthlyProgressList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "ติดตามความก้าวหน้า (รายเดือน)",
    },
    component: MonthlyProgressList,
  },
  {
    path: "/monthly-progress-info",
    name: "MonthlyProgressForm",
    meta: {
      parentName: "MonthlyProgressList",
      bcName: "รายงานผลดำเนินการ",
    },
    component: MonthlyProgressForm,
  },
  {
    path: "/project-offer",
    name: "MainProjectOffer",
    meta: {
      parentName: "ProjectManagement",
      bcName: "โครงการหลักที่ยื่นเสนอ สป.อว",
    },
    component: MainProjectOffer,
  },
  {
    path: "/offer-from-rsp",
    name: "ProjectOfferFromRSP",
    meta: {
      parentName: "ProjectManagement",
      bcName: "โครงการที่รับยื่นจาก RSP และผลพิจารณา",
    },
    component: ProjectOfferFromRSP,
  },
  {
    path: "/progress-report",
    name: "ProgressReportList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้า",
    },
    component: ProgressReportList,
  },
  {
    path: "/progress-report-offer",
    name: "ProgressReportOfferList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่ยื่น สป.อว.",
    },
    component: ProgressReportOfferList,
  },
  {
    path: "/report-from-rsp",
    name: "ReportFromRSPList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก RSP",
    },
    component: ReportFromRSPList,
  },

  // USP Extend Time
  {
    path: "/usp/extend-time",
    name: "USPExtendTimeList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก USP",
    },
    component: USPExtendTimeList,
  },
  {
    path: "/usp/extend-time/:form_c_id/form/",
    name: "USPExtendTimeFormCreate",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก USP",
    },
    component: USPExtendTimeForm,
  },
  {
    path: "/usp/extend-time/:form_c_id/form/:id",
    name: "USPExtendTimeFormEdit",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก USP",
    },
    component: USPExtendTimeForm,
  },
  {
    path: "/usp/extend-time/detail/:id",
    name: "USPExtendTimeDetail",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก USP",
    },
    component: USPExtendTimeDetail,
  },

  // RSP Extend Time
  {
    path: "/rsp/extend-time",
    name: "RSPExtendTimeList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก RSP",
    },
    component: RSPExtendTimeList,
  },
  {
    path: "/rsp/extend-time/:plan_id/form",
    name: "RSPExtendTimeFormCreate",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก RSP",
    },
    component: RSPExtendTimeForm,
  },
  {
    path: "/rsp/extend-time/:plan_id/form/:id",
    name: "RSPExtendTimeFormEdit",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก RSP",
    },
    component: RSPExtendTimeForm,
  },
  {
    path: "/rsp/extend-time/detail/:id",
    name: "RSPExtendTimeDetail",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก RSP",
    },
    component: RSPExtendTimeDetail,
  },

  // SP Extend Time
  {
    path: "/sp/extend-time",
    name: "SPExtendTimeList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก SP",
    },
    component: SPExtendTimeList,
  },
  {
    path: "/sp/extend-time/form",
    name: "SPExtendTimeFormCreate",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก SP",
    },
    component: SPExtendTimeForm,
  },
  {
    path: "/sp/extend-time/:plan_id/form/:id",
    name: "SPExtendTimeFormEdit",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก SP",
    },
    component: SPExtendTimeForm,
  },
  {
    path: "/sp/extend-time/:plan_id/detail/:id",
    name: "SPExtendTimeDetail",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก SP",
    },
    component: SPExtendTimeDetail,
  },
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        top: 0,
        behavior: "smooth",
      };
    }
  },
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // if (!getCookie__c('session_login')) {
    //   if (from.name !== 'Login') {
    //     next({
    //       name: 'Login'
    //     })
    //   }
    // } else {
    next();
    // }
  } else {
    next();
  }
});

export default router;
